import { render, staticRenderFns } from "./RecoverPasswordRedirect.vue?vue&type=template&id=02edc0ba&scoped=true&"
import script from "./RecoverPasswordRedirect.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordRedirect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02edc0ba",
  null
  
)

export default component.exports